module.exports = __webpack_public_path__ + "img/Blog-Image@3x.cde6b13f.png";